<div class="bg-light min-vh-100 d-flex align-items-center">
    <div class="mx-auto w-100" style="max-width: 480px; padding: 16px;">
        <c-card>
            <c-card-body class="p-4 text-center">
                <svg cIcon name="cilCompass" size="3xl" class="text-secondary mb-3"></svg>
                <h4 class="mb-2">You are lost</h4>
                <p class="text-muted mb-4">
                    The page you're looking for doesn't exist.
                </p>
                <button (click)="goHome()" cButton color="primary">Go Home</button>
            </c-card-body>
        </c-card>
    </div>
</div>
